import { AdminScreen } from "@/src/screens/admin-screen";

export default function AdminRoute() {
  return <AdminScreen />;
}
